import { createStore } from 'vuex';
import { dispatchActionForAllModules } from '@/utils/dispatch-action-for-all-modules.js';
import { allModules } from '@/state/modules/index.js';

const store = createStore({
  strict: process.env.NODE_ENV !== 'production',
  // global
  actions: {
    // triggers reset of all the modules to clear out the vuex store.
    resetStore() {
      dispatchActionForAllModules('reset');
    },
  },

  modules: allModules,
});

// Automatically run the `init` action for every module
dispatchActionForAllModules('init');

export { store };
